// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TOOLBAR_REPLYING_TO = "Odpoved\u00e1\u0161 na:";
